import(/* webpackMode: "eager" */ "/workspace/src/app/fastorder/page.tsx");
